import styled from 'styled-components';
import { COLORS } from '../../constants/radar';

// MainContainer for the grid-based layout
export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

// ControlsContainer with show/hide toggle (matches Meetings pattern)
export const ControlsContainer = styled.div`
  display: ${props => props.$show ? 'flex' : 'none'};
  align-items: center;
  gap: 10px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 24px;
`;

export const SessionGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 24px;
  width: 100%;
  align-items: start;
`;

export const SessionCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
  align-self: start;
  position: relative;

  '&:hover': {
    backgroundColor: '#f1f3f5',
    borderColor: '#bdbdbd',
  }
`;

export const StatusChip = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const SessionCardContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 180px;
`;

export const SessionTitle = styled.div`
  margin: 0;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  margin-bottom: 8px;
  font-size: 16px;
  padding-right: 100px; /* Make space for the status chip */
`;

export const BusinessUnitName = styled.div`
  color: #64748B;
  font-size: 14px;
  margin-bottom: 16px;
`;

export const SessionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #475569;
  font-size: 14px;

  svg {
    color: #94A3B8;
    font-size: 16px;
  }
`; 